

export default class SuperEvent {

    type!: string
    
    constructor(event: any){
        this.type = event.event
    }
}